import { useParams } from "react-router-dom";
import { FiAlertTriangle, FiInbox } from "react-icons/fi";
import CategoryNav from "../components/CategoryNav";
import Product from "../components/Product";
import ProductGrid from "../components/ProductGrid";
import ProductGridSkeleton from "../components/ui/ProductGridSkeleton";
import StateMessage from "../components/ui/StateMessage";
import useFetch from "../hook/useFetch";

export default function Products() {
  const { id } = useParams();
  // get products based on category slug — endpoint returns { category, products }
  const { data, isLoading, error } = useFetch(`/categories/categories/${id}`);

  const categoryName = data?.category?.name;
  const products = data?.products ?? [];

  return (
    <div className="mb-16 pt-40 lg:pt-0">
      <div className="container mx-auto">
        <div className="flex gap-x-[30px]">
          <CategoryNav />
          <main className="w-full">
            <div className="py-3 text-xl uppercase text-center lg:text-left">
              {isLoading
                ? "Loading category…"
                : categoryName
                ? `${categoryName} cameras`
                : "Products"}
            </div>
            {isLoading ? (
              <ProductGridSkeleton />
            ) : error ? (
              <StateMessage
                icon={FiAlertTriangle}
                title="Something went wrong"
                message="We couldn't load these products. Please try again later."
              />
            ) : products.length === 0 ? (
              <StateMessage
                icon={FiInbox}
                title="No products yet"
                message="There are no cameras in this category right now."
              />
            ) : (
              <ProductGrid>
                {products.map((product) => (
                  <Product product={product} key={product._id} />
                ))}
              </ProductGrid>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
